// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TipLink_wrapper__9Jeue","icon":"TipLink_icon__AzCT6","borderColor":"TipLink_borderColor__vf736","link":"TipLink_link__he7mV"};